<template>
  <button
    @click.prevent="handleClick"
    class="action-button"
    :data-active="active"
    :data-type="type"
    :disabled="disabled"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "ActionButton",
  props: ["active", "disabled", "type"],
  methods: {
    handleClick() {
      this.$emit("click");
    }
  }
}
</script>

<style lang="scss" scoped>
  $border-width: 4px;
  $width: 50px + $border-width;
  $padding: 12px;

  $color-next: $color-blue;
  $color-back: $color-red;

  .action-button {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    height: $width;
    width: $width;
    padding: $padding;
    margin: 0;
    text-align: center;
    border-radius: $width;
    border: solid $border-width $color-white;
    cursor: pointer;
    transition: none;

    &[data-type="next"] {
      border-color: $color-next;
      color: $color-white;
      background-color: $color-next;
      &::v-deep svg, * {
        color: $color-white;
        fill: $color-white;
      }
      &:hover, &[data-active=true] {
        background-color: $color-white;
        // border-color: $color-white;
        color: $color-next;

        &::v-deep svg, * {
          color: $color-next;
          fill: $color-next;
        }
      }
    }
    &[data-type="back"] {
      border-color: $color-back;
      color: $color-white;
      background-color: $color-back;
      &::v-deep svg, * {
        color: $color-white;
        fill: $color-white;
      }
      &:hover, &[data-active=true] {
        background-color: $color-white;
        // border-color: $color-white;
        color: $color-back;

        &::v-deep svg, * {
          color: $color-back;
          fill: $color-back;
        }
      }
    }

    &:hover, &[data-active=true] {
      background-color: $color-grey;
      // border-color: $color-white;
      color: $color-white;

      &::v-deep svg, * {
        color: $color-white;
        fill: $color-white;
      }
    }

    &::v-deep svg, * {
      max-height: 100%;
      width: 100%;
      transition: none;
    }

  }
</style>
